import styled from 'styled-components';

export const HostingQualityTitle = styled.h1`
  font-size: 24px;
  font-weight: 300;
  display: flex;
  align-items: center;

  svg {
    width: 22px;
    margin-left: 5px;
  }
`;

export const HostingQualitySubtitle = styled.h2`
  font-size: 16px;
  color: #737373;
  display: flex;
  align-items: center;

  svg {
    width: 22px;
    margin-left: 5px;
  }
`;
